export class I18nMessage {
  messageKey: string;
  parameters?: {
    [key: string]: any;
  };
}
